import React from 'react'
// import milanAnimation from '../json/milan.json'
// import milanBlackAnimation from '../json/milan-black.json'
// import Lottie from 'lottie-web'
import { withRouter } from 'react-router-dom';

import Superface from '../Superface'

const ANGLES = {
    'N' : 90,
    'E' : 180,
    'S' : 270,
    'W' : 0,
    'center' : 0,
}

class Compass extends React.Component {
    
    direction = 1

    options = {
        renderer: 'svg',
        loop: true,
        autoplay: false,
        // animationData : milanAnimation
    }

    oldCardinal = 'W'
    lastAngle = 0

    constructor(props){
        super(props)
        this.handleMouseMove = this.handleMouseMove.bind(this)
        this.handleMouseDown = this.handleMouseDown.bind(this)
    }
    
    componentWillMount(){
        this.setState({
            mounted : false
        })
    }

    componentDidMount(){
        
        this.timeoutMount = setTimeout( () => {
            this.setState({
                ...this.state, mounted : true
            }) 
        }, 600)

        window.addEventListener('mousemove', this.handleMouseMove)
        window.addEventListener('mousedown', this.handleMouseDown)
       
    }

    componentWillReceiveProps(new_props){
        if( this.props.cardinal !== new_props.cardinal ){
            this.oldCardinal = this.props.cardinal
        }
    }

    componentWillUnmount(){
        if( this.timeoutMount ) clearTimeout( this.timeoutMount )
        window.removeEventListener('mousemove', this.handleMouseMove)
    }
    
    handleMouseMove(e){
        if( this.props.section !== 'accueil' ) return
        
        const setCompass = Superface.setCompass
        
        const xFromCenter = e.pageX - ( window.innerWidth / 2 )
        const yFromCenter = e.pageY - ( window.innerHeight / 2 )
        let angleRad = Math.atan( yFromCenter / xFromCenter )
        
        if( xFromCenter > 0 ){ 
            angleRad += Math.PI
        }else{
            if( yFromCenter > 0 ){
                angleRad = 2 * Math.PI + angleRad
            }
        }

        let degree = angleRad * 180 / Math.PI
        if( degree > 45 && degree <= 135 ) setCompass('N')
        else if( degree > 135 && degree <= 225 ) setCompass('E')
        else if( degree > 225 && degree <= 315 ) setCompass('S')
        else setCompass('W')

    }
    
    handleMouseDown(){
        // if( this.props.section !== 'accueil' ) return
        // switch(this.props.cardinal){
        //     case 'N':
        //         Superface.goTo(Superface.uri('contact'))
        //         break;
        //     case 'S':
        //         Superface.goTo(Superface.uri('notre-metier'))
        //         break;
        //     case 'W':
        //         Superface.goTo(Superface.uri('matieres'))
        //         break;
        //     case 'E':
        //         Superface.goTo(Superface.uri('projets'))
        //         break;
        // }
    }

    renderSectionTitle(){
        if( this.props.section !== 'accueil' && !this.props.menuOpen ){
            let fontStyle = { position : 'absolute', left : '7rem', top :'2rem', width:'9rem' }
            return(
                <div style={fontStyle}>
                    { Superface.translate(Superface.getSectionName(this.props.section)) }
                </div>
            )
        }
    }

    render(){
        const squareWidth = '6rem'
        const { section, menuOpen, cardinal } = this.props
        let style = { width: squareWidth, height: squareWidth, position : 'fixed', left:'2rem', top:'2rem', zIndex:1352}
        let squareStyle = {width: squareWidth, height: squareWidth, position : 'absolute', left:0, top:0}
        
        let rotate
       
        if( this.props.cardinal !== this.oldCardinal ){
            let finalAngle = ANGLES[this.props.cardinal]
            let angleOffset = finalAngle - ANGLES[this.oldCardinal]
            if(angleOffset > 180) angleOffset = 180 - angleOffset
            if(angleOffset < -180) angleOffset += 360
            
            let currentAngle = this.lastAngle + angleOffset
            this.lastAngle = ( currentAngle % 360  === 0 ? 0 : currentAngle )
            this.oldCardinal = this.props.cardinal
            rotate = 'rotate(' + currentAngle + 'deg)'
        }else{
            rotate = this.lastRotate
        }
        this.lastRotate = rotate
        let classNamesBase = ( Superface.IS_MOBILE ? `compass-mobile opacity-${ this.props.hidden ? '0' : '1' }` : '' )

        return(
            <div id="compass" className={classNamesBase + ( this.state.mounted ? ' mounted' : '')} style={style} >
                {this.renderSectionTitle()}
                <div 
                    ref={ stroke => this.stroke = stroke }
                    onClick={ (e) => { if(menuOpen) Superface.toggleMenu(); Superface.goTo( Superface.uri('accueil') ) }} 
                    style={{ transform: rotate , cursor: 'pointer', position : 'absolute', zIndex : 5000, width:squareWidth, height:squareWidth}} 
                    className={'stroke-container'}
                    >
                    <div className={"stroke-index " + ( section !== 'accueil' ? 'shown' : '')} style={squareStyle}>
                        <img src={require('../images/milan-circle-index.svg')} alt='Superface pièce de Milan'/>
                    </div>
                    <div className={"stroke-index " + ( section !== 'accueil' ? '' : 'shown')} style={squareStyle}>
                        <img src={require('../images/milan-circle-index-white.svg')} alt='Superface pièce de Milan'/>
                    </div>
                </div>
                
                <div className={"logo-index " + ( section !== 'accueil' ? 'shown' : '')} style={squareStyle}>
                    <img src={require('../images/milan-circle.svg')} alt='Superface pièce de Milan'/>
                </div>
                
                <div className={"logo-index " + ( section !== 'accueil' ? '' : 'shown')} style={squareStyle}>
                    <img src={require('../images/milan-circle-white.svg')} alt='Superface pièce de Milan'/>
                </div>
                
            </div>
        )
    }
}

export default withRouter(Compass)



// WEBPACK FOOTER //
// ./src/components/_Compass.js